import React from 'react';
import { ArrowForward } from '@yme/assets/icons';
import { Button, CONTAINED_VARIANT, SIZE_44, TRAILING_ICON } from '@yme/atoms/button';
import { GridWrapper } from '@yme/atoms/grid';
import { isExternalLink, onOpenWindow } from '@yme/utils/common';
import { BLANK, SELF } from '@yme/utils/constants';
import { BodyTextStyled, ButtonsSectionStyled, HeroSectionThemeStyled } from './styled';
export function HeroSectionTheme({ currentColorTheme, description, buttonSettings, isRightToLeft, }) {
    const onClickHandler = (link) => {
        if (!link) {
            return;
        }
        onOpenWindow(link, isExternalLink(link) ? BLANK : SELF);
    };
    return (React.createElement(HeroSectionThemeStyled, { backgroundColor: currentColorTheme },
        React.createElement(GridWrapper, null,
            description && React.createElement(BodyTextStyled, { isResetPadding: true }, description),
            buttonSettings && (React.createElement(ButtonsSectionStyled, { isResetPadding: !description },
                React.createElement(Button, { buttonVariant: CONTAINED_VARIANT, hasIconButton: TRAILING_ICON, iconComponent: ArrowForward, size: SIZE_44, isRightToLeft: isRightToLeft, label: buttonSettings.text, isDarkMode: true, onClick: () => onClickHandler(buttonSettings?.link) }))))));
}
HeroSectionTheme.displayName = 'HeroSectionTheme_Component';
